import type { NavItem } from "~/components/header/types"

interface Props {
    items: NavItem[]
}

export default function DesktopNavbar({ items }: Props) {
    if (!items?.length) return null

    return (
        <ul data-prerender className='flex flex-wrap items-center h-full overflow-hidden'>
            {items.map(({ name, url, items, categories, isGridOf2Cols }, i) => (
                <li key={url ?? `${name}-${i}`} className='flex items-center h-full group hover:bg-salmon'>
                    {/* Top-level item may be a dropdown-only entry with no url,
                        so it stays a plain <a>. The prefetch targets sit on the
                        dropdown sub-links below (always real PLP urls). */}
                    {url
                        ? (
                            <a href={url} className='flex items-center h-full px-1 min-[1366px]:px-2'>
                                <span className='max-2xl:text-xs font-bold text-sm'>{name}</span>
                            </a>
                        )
                        : (
                            <span className='flex items-center h-full px-1 min-[1366px]:px-2'>
                                <span className='max-2xl:text-xs font-bold text-sm'>{name}</span>
                            </span>
                        )}

                    {Boolean(items?.length) && (
                        <div className='text-sm absolute hidden hover:flex group-hover:flex bg-white bg-opacity-[0.92] z-20 items-start gap-6 border-t-[6px] border-salmon text-neutral-400 left-0 right-0 top-full px-[10%] py-8'>
                            <ul
                                className={`grid gap-2.5 ${
                                    isGridOf2Cols ? 'grid-cols-2' : 'grid-cols-3'
                                }`}
                            >
                                {items!.map((node, ni) => (
                                    <li key={`${name ?? i}::${node.url ?? node.name ?? ni}`} className='min-w-[236px]'>
                                        <a
                                            className='hover:underline underline-offset-2 text-[15px] text-[#5A5A5A] hover:text-salmon w-full'
                                            href={node.url}
                                        >
                                            <span>{node.name}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>

                            <ul className='flex flex-col w-1/4 gap-2.5'>
                                {Boolean(categories?.length) && (
                                    <>
                                        {categories!.map((category, ci) => (
                                            <li key={category.name ?? ci}>
                                                <span className='font-bold text-salmon block mb-2 text-[15px]'>
                                                    {category.name}
                                                </span>

                                                <ul className='flex flex-col gap-2.5'>
                                                    {category.items.map((item, ii) => (
                                                        <li key={`${ci}-${ii}-${item.url ?? item.name ?? ''}`} className='min-w-[236px]'>
                                                            <a
                                                                className='hover:underline underline-offset-2 hover:text-salmon text-[15px] text-[#5A5A5A] w-full'
                                                                href={item.url}
                                                            >
                                                                <span>{item.name}</span>
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        ))}
                                    </>
                                )}
                            </ul>
                        </div>
                    )}
                </li>
            ))}
        </ul>
    )
}
